import { render } from "./ReportOption.vue?vue&type=template&id=80a36bc0&ts=true"
import script from "./ReportOption.vue?vue&type=script&lang=ts"
export * from "./ReportOption.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__